import { ApiService } from "../../../config";
import type { IHistoricoDePosicoes } from "../types";

const getHistoricoDePosicoes = async (
  profileId: string,
  months = 12,
): Promise<IHistoricoDePosicoes | null> => {
  try {
    const response = await ApiService.get(
      `/dashboard/profile/${profileId}/positions-history`,
      { params: { months } },
    );
    const { data, error } = response.data;
    return error ? null : (data as IHistoricoDePosicoes);
  } catch {
    return null;
  }
};

export const RelatorioService = {
  getHistoricoDePosicoes,
};
